import styled from "styled-components";
export const GeneralStyle = styled.div`
  position: relative;
  align-items: center;
  justify-self: center;
  ${({ isDependent, theme }) =>
    isDependent && `border-left: ${theme.primary.blue} solid !important;`}
  display: grid;
  margin: 1em;
  max-width: 710px;
  grid-template-columns: 1fr;
  font-size: 14px;
  border-radius: 5px;
  padding: 1em 2em;
  word-break: break-word;
  width: 100%;
  background: ${(props) =>
    props.colorBackground === "#f9f9f9"
      ? "transparent"
      : props.colorBackground};
  opacity: 0.95;
  box-shadow: ${({ editable }) =>
    editable && "0px 0px 10px rgba(0, 0, 0, 0.3);"};
  border-radius: 4px;
  @media only screen and (max-width: 495px) {
    grid-template-columns: 100%;
  }
  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
  }
  :focus .overlay-option,
  :active .overlay-option,
  :hover .overlay-option {
    opacity: 1;
  }
  .overlay-option {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba(46, 46, 46, 0.2);
  }

  .bottom-buttons {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    @media only screen and (max-width: 475px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
  }
`;

export const EditSection = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr;
  font-size: 14px;
  border-radius: 5px;
  word-break: break-word;
  background: ${({ theme }) => theme.background.secondary};
  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const UpperWrapper = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr;
  align-items: center;
  grid-gap: 1em;

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.text.secondary};
  }

  input::placeholder {
    font-size: 12px;
  }

  #mText {
    grid-column: 1;
    grid-row: 2;
  }
`;

export const VSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  align-items: center;
  @media only screen and (max-width: 495px) {
    grid-template-columns: 1fr;
  }
  input {
    justify-self: left;
    height: 2em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[200]};
    background: ${({ theme }) => theme.background.light};
    outline: none;
    padding: 1em 0.5em;
    font-size: small;
    border-radius: 3px;
  }

  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
    width: auto;
    justify-self: flex-start;
    align-self: center;
  }

  .MuiFormControlLabel-root svg {
    height: 15px;
    width: 15px;
  }

  .MuiFormControlLabel-label {
    font-size: 13px;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.primary.purple};
  }
`;

export const QuestionWrapper = styled.div`
  display: grid;
  padding: 0.4em;
  align-items: center;

  label {
    font-weight: 700;
  }

  textarea {
    padding: 1rem;
    width: 100%;
    height: 6em;
    outline: 0;
    border: none;
    background: ${({ theme }) => theme.background.light};
    border-radius: 4px;
    box-sizing: border-box;
    font-size: small;
    color: ${({ theme }) => theme.primaryIconColor};
    resize: none;
  }
`;
export const CategorySection = styled.div`
  display: grid;
  padding: 0.4em;
  grid-template-columns: 100%;
  grid-gap: 1em;

  label {
    font-weight: 700;
    font-size: small;
  }

  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.border.medium};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }
`;

export const QuestionPosition = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  align-content: center;

  div {
    display: grid;
    background: ${({ theme }) => theme.background.light};
    justify-content: center;
    align-content: center;
    height: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[200]};
  }

  input {
    border: 1px solid ${({ theme }) => theme.neutral.gray[200]};
    border-radius: 0px 3px 3px 0;
    font-weight: 700;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    opacity: 1;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  padding: 0.6em;
  border: 1px solid ${({ theme }) => theme.button.primary};
  border-radius: 0 5px 5px 0;
    background: ${({ theme }) => theme.button.primary};
  align-items: center;
  justify-content: center;
  svg {
    width: 60% !important;
    fill: ${({ theme }) => theme.neutral.white};
  }
`;

export const LowerWrapper = styled.div`
  display: grid;
  padding: 1em 1.5em;
  grid-auto-rows: 0.2fr 100px;
  align-items: center;
  border-radius: 1px;
  textarea {
    resize: none;
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.border.medium};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  @media only screen and (max-width: 495px) {
    flex-direction: column;
    align-items: center;
  }
  .left-container {
    margin-left: 20px;
    display: flex;
    width: 70%;
    @media only screen and (max-width: 495px) {
      width: fit-content;
    }
  }
  .right-container {
    display: flex;
    width: 30%;
    justify-content: end;
  }
`;
export const ContainerTitle = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${({ theme }) => theme.text.primary};
  .active {
    color: ${({ theme }) => theme.primary.purple};
  }
`;

export const PreviewWrapper = styled.label`
  font-weight: 700 !important;
`;

export const ReqFieldMandatory = styled.div`
  color: ${({ theme }) => theme.status.error};
  font-size: 21px;
  font-weight: 400 !important;
  margin-left: 240px;
`;

export const ReqField = styled.span`
  color: ${({ theme }) => theme.status.error};
  font-size: 21px;
`;

export const EditButton = styled.button`
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  float: right;
  height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.white};
  max-width: 80px;
  max-height: 31px;
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;

export const DeleteButton = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 4px;
  height: 40px;
  max-height: 31px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.gray[2600]};
  float: right;
  font-size: 14px;
  font-weight: 500;
  max-width: 80px;
  &:hover {
    opacity: 0.9;
  }
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;

export const CloneButton = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 4px;
  height: 31px;
  max-height: 31px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.black};
  float: left;
  font-size: 14px;
  font-weight: 500;
  max-width: 90px;
  left: 0;
  position: absolute;
  &:hover {
    opacity: 0.9;
  }
  svg {
    width: auto !important;
    height: auto !important;
  }
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;

export const SaveToBank = styled.button`
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  float: left;
  height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.white};
  max-width: 110px;
  max-height: 31px;
  position: absolute;
  left: 120px;
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;

export const TooltipCheckSection = styled.div`
  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
    width: auto;
    justify-self: flex-start;
    align-self: center;
  }

  .MuiFormControlLabel-root svg {
    height: 20px;
    width: 20px;
    color: ${({ theme }) => theme.neutral.black};
  }

  .MuiFormControlLabel-label {
    font-size: 13px;
    font-weight: bold;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.neutral.black};
  }
`;

export const TooltipDescriptionContainer = styled.div`
  textarea {
    justify-self: left;
    height: 2em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.border.medium};
    background: ${({ theme }) => theme.neutral.white};
    outline: none;
    padding: 1em 0.5em;
    font-size: small;
    border-radius: 3px;
  }
`;

export const UploadInputContainer = styled.div`
  Button {
    font-family: "Noto Sans", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: ${({ theme }) => theme.text.primary};
    background-color: ${({ theme }) => theme.neutral.gray[700]};
    margin-top: 0px !important;
    padding: 4px 5px;
  }
`;
